import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_social-youtube",
  "use": "svg_social-youtube-usage",
  "viewBox": "0 0 18.5 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.5 18\" id=\"svg_social-youtube\"><path fill=\"currentColor\" d=\"M17.8 4.8c-.2-.8-.8-1.4-1.6-1.6-1.4-.4-7-.4-7-.4s-5.6 0-7 .4c-.8.2-1.4.9-1.6 1.6C.2 6.3.2 9.2.2 9.2s0 2.9.4 4.4c.2.7.8 1.4 1.6 1.6 1.4.4 7 .4 7 .4s5.6 0 7-.4c.8-.2 1.4-.8 1.6-1.6.4-1.5.4-4.4.4-4.4s0-2.9-.4-4.4zM7.4 11.9V6.5l4.7 2.7-4.7 2.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol